import { DrEntity } from "./dr-entity";
import { DrObject, DrObjectType, SupportedRegExType } from './dr-object';

export class BatchViewModel extends DrObject {
    model: Partial<Batch>;
    constructor(value?: Partial<Batch>) {
        super(DrObjectType.BATCH, SupportedRegExType.METADATAVIEW);
        if (value) {
            this.model = value;
        }
    }
}
export class Batch extends DrEntity {
    name: string;
    description: string;
    documentCount: number;
    dateCreated: string;
    archived: boolean;
    emailAddresses: Array<string>;
    handle: string;
    priority: number;
    userIds: Array<string>;

    // off-model display values
    iconClass: string;
    iconColor: string;

    constructor(value?: Partial<Batch>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }

        this.iconClass = 'fa-archive';
        this.iconColor = this.name === 'Unassigned' ? 'color-grey-08' : 'color-blue-01';

    }
}